"use strict";
var cloneDeep = require("lodash/cloneDeep");
var DEFAULT_SUBMISSION_TEXT = "Save AP Subjects";
var SAVING_SUBMISSION_TEXT = "Saving AP Subjects ...";
var SetApProgramsController = (function () {
    /* @ngInject */
    function SetApProgramsController($route, userSessionService, studyProgramsService, $rootScope, $location) {
        var _this = this;
        this.$route = $route;
        this.userSessionService = userSessionService;
        this.studyProgramsService = studyProgramsService;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.submittingPrograms = false;
        this.selectedPrograms = [];
        this.activeStudyPrograms = [];
        this.pendingStudyPrograms = [];
        this.goHome = function () {
            if (_this.userSessionService.isDistrictMode()) {
                _this.$location.path("/" + _this.userSessionService.getDistrictTenantId());
            }
            else {
                _this.$location.path("/" + _this.tenantId);
            }
        };
        this.errorCallback = function () {
            _this.pendingStudyPrograms = [];
            _this.submittingPrograms = false;
            _this.$rootScope.loadingError = true;
        };
        this.successCallback = function (status) {
            if (status >= 400) {
                _this.errorCallback();
            }
            else {
                _this.subscriptionStudyPrograms.studyPrograms = _this.pendingStudyPrograms;
                _this.pendingStudyPrograms = [];
                _this.loadStudyPrograms();
                _this.submittingPrograms = false;
            }
        };
    }
    SetApProgramsController.prototype.$onInit = function () {
        this.district = this.userSessionService.isDistrictMode();
        if (this.district) {
            this.tenantId = this.userSessionService.getDistrictTenantId();
        }
        else {
            this.tenantId = this.$route.current.params.tenantId;
        }
        var locals = this.$route.current.locals;
        this.subscriptionStudyPrograms = locals.subscriptionStudyPrograms;
        this.loadStudyPrograms();
        this.updateCrumbs();
    };
    SetApProgramsController.prototype.isAllSubscriptionsActivated = function () {
        return this.activeStudyPrograms.length === this.subscriptionStudyPrograms.apCount;
    };
    SetApProgramsController.prototype.getPrograms = function () {
        return this.subscriptionStudyPrograms.studyPrograms;
    };
    SetApProgramsController.prototype.getAbsUnselectedProgramCount = function () {
        return Math.abs(this.getUnselectedProgramCount());
    };
    SetApProgramsController.prototype.getUnselectedProgramCount = function () {
        if (!this.subscriptionStudyPrograms.apCount) {
            return 0;
        }
        return this.subscriptionStudyPrograms.apCount - this.selectedPrograms.length;
    };
    SetApProgramsController.prototype.areRemainingProgramsToBeSelected = function () {
        return this.getUnselectedProgramCount() > 0;
    };
    SetApProgramsController.prototype.isUnselectedPrograms = function (count) {
        return this.getUnselectedProgramCount() === count;
    };
    SetApProgramsController.prototype.moreProgramsToBeSelected = function (count) {
        return this.getUnselectedProgramCount() < count;
    };
    SetApProgramsController.prototype.isDisabledProgram = function (courseSlug) {
        if (this.submittingPrograms || !courseSlug || this.isAllSubscriptionsActivated()) {
            return true;
        }
        if (this.getUnselectedProgramCount() > 0) {
            return false;
        }
        return !this.isSelectedProgram(courseSlug);
    };
    SetApProgramsController.prototype.isSelectedProgram = function (courseSlug) {
        return courseSlug && this.selectedPrograms.indexOf(courseSlug) >= 0;
    };
    SetApProgramsController.prototype.toggleProgram = function (courseSlug) {
        if (!courseSlug || this.isAllSubscriptionsActivated()) {
            return false;
        }
        var selected = false;
        var selectedProgramIndex = this.selectedPrograms.indexOf(courseSlug);
        if (selectedProgramIndex >= 0) {
            this.selectedPrograms.splice(selectedProgramIndex, 1);
        }
        else if (this.getUnselectedProgramCount() > 0) {
            this.selectedPrograms.push(courseSlug);
            selected = true;
        }
        return selected;
    };
    ;
    SetApProgramsController.prototype.submitReady = function () {
        return this.selectedPrograms.length === this.subscriptionStudyPrograms.apCount;
    };
    SetApProgramsController.prototype.getSubmissionText = function () {
        return (this.submittingPrograms) ? SAVING_SUBMISSION_TEXT : DEFAULT_SUBMISSION_TEXT;
    };
    SetApProgramsController.prototype.submit = function () {
        if (!this.submittingPrograms) {
            this.$rootScope.loadingError = false;
            if (!this.submitReady()) {
                this.$rootScope.loadingError = true;
            }
            else {
                this.submittingPrograms = true;
                this.pendingStudyPrograms = [];
                for (var _i = 0, _a = this.subscriptionStudyPrograms.studyPrograms; _i < _a.length; _i++) {
                    var studyProgram = _a[_i];
                    var pendingStudyProgram = cloneDeep(studyProgram);
                    this.pendingStudyPrograms.push(pendingStudyProgram);
                    pendingStudyProgram.subscribed = this.selectedPrograms.indexOf(pendingStudyProgram.courseSlug) >= 0;
                }
                this.studyProgramsService.updateStudyProgramsSubscription(this.pendingStudyPrograms, this.subscriptionStudyPrograms.apCount, this.tenantId)
                    .then(this.successCallback, this.errorCallback);
            }
        }
    };
    SetApProgramsController.prototype.loadStudyPrograms = function () {
        if (this.subscriptionStudyPrograms.apCount > 0) {
            this.activeStudyPrograms = this.subscriptionStudyPrograms.studyPrograms.filter(function (studyProgram) {
                return studyProgram.subscribed;
            });
            if (this.subscriptionStudyPrograms.apCount === this.subscriptionStudyPrograms.studyPrograms.length) {
                // Default all Study Programs to selected
                for (var _i = 0, _a = this.subscriptionStudyPrograms.studyPrograms; _i < _a.length; _i++) {
                    var studyProgram = _a[_i];
                    this.selectedPrograms.push(studyProgram.courseSlug);
                }
            }
        }
    };
    SetApProgramsController.prototype.updateCrumbs = function () {
        if (this.district) {
            this.crumbs = [
                { name: "Naviance Test Prep: District", url: "" + this.tenantId },
                { name: "Setup AP Study Programs" }
            ];
        }
        else {
            this.crumbs = [
                { name: "Naviance Test Prep", url: "" + this.tenantId },
                { name: "Setup AP Study Programs" }
            ];
        }
    };
    return SetApProgramsController;
}());
exports.SetApProgramsController = SetApProgramsController;



/** WEBPACK FOOTER **
 ** ./app/set-ap-programs/set-ap-programs.controller.ts
 **/